import { Heading as _Heading, FONT_SIZE, mq, COLOR, FONT_WEIGHT } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivTopGrid = styled.div`
  display: grid;
  grid-gap: 8px;
`;

export const DivBottomGrid = styled.div`
  display: grid;
  grid-gap: 16px;
  margin-top: 8px;
`;

export const SpanTitleName = styled.span`
  display: block;
  font-size: 14px;
`;

export const SpanSeasonName = styled.span`
  display: block;
  font-size: 14px;
`;

export const Heading = styled(_Heading)`
  font-size: 24px;
  font-weight: ${FONT_WEIGHT.NORMAL};

  ${mq.sp} {
    font-size: ${FONT_SIZE.L}px;
  }
`;

export const ParVrText = styled.p`
  color: ${COLOR.ERROR.code};
  font-size: 14px;
`;
